/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespLayout_viewer = {|
  +isPdpUrlTranslationEnabled: ?boolean;
  +localDeliveryOptions?: ?{| |};
  +domesticDeliveryOptions?: ?{| |};
  +user?: ?{| |};
  +vipUserRelationships?: ?$ReadOnlyArray<?{| |}>;
  +item?: ?{|
    +isAvailable: ?boolean;
    +microdata: ?string;
    +pdpURL: ?string;
    +localizedPdpUrl: ?string;
    +pdpMeta: ?{|
      +title: ?string;
      +description: ?string;
      +ogTitle: ?string;
      +productPriceAmount: ?string;
      +productPriceCurrency: ?string;
    |};
    +photos: ?$ReadOnlyArray<?{|
      +versions: ?$ReadOnlyArray<?{|
        +webPath: ?string;
        +type: ?{|
          +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master" | "placeholder";
        |};
      |}>;
    |}>;
    +isListingNotListed: ?boolean;
    +seller: ?{|
      +isInternal: ?boolean;
      +serviceId: ?string;
    |};
    +saveSearchData: ?{|
      +page: ?string;
    |};
    +canShowViewInRoom: ?boolean;
    +contemporaryTrackingString: string;
    +displayInfo?: ?{| |};
    +pdpTrackingVpvParams?: ?any;
    +sellerItems: ?{| |};
    +similarLandingItems: ?{| |};
    +similarGridItems: ?{| |};
    +pdpTypeDisplay: ?"DEFAULT" | "UNPURCHASABLE" | "NOT_LISTED";
    +attributes: ?{|
      +period: ?$ReadOnlyArray<?{|
        +option: ?{|
          +name: ?string;
        |};
      |}>;
    |};
    +browseUrl: ?string;
    +categoryCode: ?string;
  |};
  +hasFetchedOnClient: "Viewer";
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchPdp",
      "type": "Boolean",
      "defaultValue": true
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "newAndCustomSplitTest",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "relationshipUserIds",
      "type": "[String]!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespLayout_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespContainerNotListed_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isPdpUrlTranslationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "translatedPdpUrls",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"translatedPdpUrls\"}"
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedCurrencyLoader_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId",
              "type": "String!"
            }
          ],
          "concreteType": "Item",
          "name": "item",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "SaveSearchDataType",
              "name": "saveSearchData",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "page",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "isAvailable",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "pdpURL",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "localizedPdpUrl",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "pdpMetaItems",
              "name": "pdpMeta",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "title",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "description",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "ogTitle",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "productPriceAmount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "productPriceCurrency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ItemPhoto",
              "name": "photos",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "name": "versions",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "webPath",
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "ImageVersionType",
                      "name": "type",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "isListingNotListed",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "name": "seller",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "isInternal",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "serviceId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_item",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainerNotListed_item",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "microdata",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "canShowViewInRoom",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "contemporaryTrackingString",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "browseUrl",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": "sellerItems",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4,
                  "type": "Int"
                },
                {
                  "kind": "Literal",
                  "name": "seller",
                  "value": "INCLUDE",
                  "type": "seller"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "name": "moreLikeThis",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_sellerItems",
                  "args": null
                }
              ],
              "storageKey": "moreLikeThis{\"first\":4,\"seller\":\"INCLUDE\"}"
            },
            {
              "kind": "LinkedField",
              "alias": "similarLandingItems",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 12,
                  "type": "Int"
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade",
                  "type": "Boolean"
                },
                {
                  "kind": "Literal",
                  "name": "priceRangePercentage",
                  "value": "5-15",
                  "type": "String"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "name": "moreLikeThis",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_similarLandingItems",
                  "args": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": "similarGridItems",
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 8,
                  "type": "Int"
                },
                {
                  "kind": "Variable",
                  "name": "isTrade",
                  "variableName": "isTrade",
                  "type": "Boolean"
                },
                {
                  "kind": "Variable",
                  "name": "newAndCustomSplitTest",
                  "variableName": "newAndCustomSplitTest",
                  "type": "Boolean"
                },
                {
                  "kind": "Literal",
                  "name": "priceRangePercentage",
                  "value": "5-15",
                  "type": "String"
                },
                {
                  "kind": "Literal",
                  "name": "seller",
                  "value": "EXCLUDE",
                  "type": "seller"
                }
              ],
              "concreteType": "moreLikeThisConnection",
              "name": "moreLikeThis",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainer_similarGridItems",
                  "args": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "PdpRespContainerNotListed_similarGridItems",
                  "args": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "pdpTypeDisplay",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ItemAttributes",
              "name": "attributes",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "AttributeValue",
                  "name": "period",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "AttributeOption",
                      "name": "option",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "categoryCode",
              "storageKey": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "isClient",
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId",
                      "type": "String"
                    },
                    {
                      "kind": "Literal",
                      "name": "page",
                      "value": "pdp",
                      "type": "PageDisplayEnum"
                    }
                  ],
                  "concreteType": "ItemDisplayInfo",
                  "name": "displayInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "PdpRespContainer_displayInfo",
                      "args": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId",
                      "type": "String"
                    }
                  ],
                  "name": "pdpTrackingVpvParams",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SharedCurrencyLoader_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainerNotListed_user",
              "args": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "vipUserRelationships",
          "args": [
            {
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "relationshipUserIds",
              "type": "[String]!"
            }
          ],
          "concreteType": "UserRelationship",
          "name": "userRelationships",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_vipUserRelationship",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "hasFetchedOnClient",
          "args": null,
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "localDeliveryOptions",
          "args": [
            {
              "kind": "Literal",
              "name": "addressResolutionType",
              "value": "IP",
              "type": "AddressResolutionType!"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "regionView",
              "value": "LOCAL",
              "type": "RegionView"
            }
          ],
          "concreteType": "ShipmentQuoteConnection",
          "name": "availableDeliveryOptions",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_localDeliveryOptions",
              "args": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "domesticDeliveryOptions",
          "args": [
            {
              "kind": "Literal",
              "name": "addressResolutionType",
              "value": "IP",
              "type": "AddressResolutionType!"
            },
            {
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId",
              "type": "String"
            },
            {
              "kind": "Literal",
              "name": "regionView",
              "value": "DOMESTIC",
              "type": "RegionView"
            }
          ],
          "concreteType": "ShipmentQuoteConnection",
          "name": "availableDeliveryOptions",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespContainer_domesticDeliveryOptions",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
